unit SpediFucsDatenmodul;

interface

uses
  System.SysUtils, System.Classes, System.UITypes, JS, Web, WEBLib.Modules, WEBLib.Dialogs, XData.Web.Client,
  WEBLib.StdCtrls, Bcl.Utils,  CP.Func.AES, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,  Vcl.Graphics,
  System.NetEncoding;

 function GetFeldWert( sFelder, sDaten, sFeldName : String ) : String;

 function ColToHtmlCol(AColor: TColor): string;
 function GetSchriftFarbe( colHintergrund: TColor) : TColor;

 function Get_UrlbAntragStatus( iNr : Integer ) : string;
 function Get_UrlbAntragEntscheidung( iNr : Integer ) : string;

 function WordCount(const S: string; const WordDelims: TSysCharSet): Integer;
 function WordPosition(const N: Integer; const S: string; const WordDelims: TSysCharSet): Integer;
 function ExtractDelimited(N: Integer; const S: string; const Delims: TSysCharSet): string;
 function ExtractWord(N: Integer; const S: string; const WordDelims: TSysCharSet): string;



type
  TdmSpediFucs = class(TDataModule)
    XDataWebClient: TXDataWebClient;
    procedure WebDataModuleCreate(Sender: TObject);

  private

  public
    function Get_PaketDaten( aVonSL, aNachSL : TStringList; sPaket : String ) : Integer;
    function Test : String ;
    [async] procedure Clear_CBX_und_Objekte( aComboBox : TComboBox ); async;

  protected procedure LoadDFMValues; override; end;


var dmSpediFucs: TdmSpediFucs;

implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}

uses UnitMain, UnitLogin, GlobalWeb;

{$R *.dfm}


//====================================================================================================================//

function ColToHtmlCol(AColor: TColor): string;
begin

  Result := IntToHex(ColorToRgb(AColor), 6);
  //console.log( ColorToString(aColor)+  ' > ' + Result)    ;
  Result := '#' + Copy(Result, 5, 2) + Copy(Result, 3, 2) + Copy(Result, 1, 2);
end;


//====================================================================================================================//

function GetSchriftFarbe( colHintergrund: TColor) : TColor;
var intensity : Integer;
begin

  colHintergrund := ColorToRGB(colHintergrund);

  intensity := GetBValue(colHintergrund) * 21 // Blue
    + GetGValue(colHintergrund) * 174 // Green
    + GetRValue(colHintergrund) * 61; // Red

   // intensity = 0 -> dark
   // intensity = 255*256 -> bright

  If intensity >= (128*256) then
       Result := clBlack
  Else Result := clWhite;

end;

//====================================================================================================================//

function Get_UrlbAntragStatus( iNr : Integer ) : string;
begin

  Case iNr Of
    10 : Result := 'Angelegt';
    20 : Result := 'Teilweise genehmigt';
    30 : Result := 'Vollständig genehmigt';
    40 : Result := 'Abgelehnt';
    50 : Result := 'Storniert';
  Else Result := '';
  End;

end;

//====================================================================================================================//

function Get_UrlbAntragEntscheidung( iNr : Integer ) : string;
begin

  Case iNr Of
    1 : Result := 'Genehmigt';
    2 : Result := 'Abgelehnt';
    3 : Result := 'Storniert';
  End;

end;

//====================================================================================================================//

function WordCount(const S: string; const WordDelims: TSysCharSet): Integer;
var  SLen, I: Cardinal;
begin
  Result := 0;
  I := 1;
  SLen := Length(S);
  while I <= SLen do
  begin
    while (I <= SLen) and CharInSet(S[I], WordDelims) do
      Inc(I);
    if I <= SLen then
      Inc(Result);
    while (I <= SLen) and not CharInSet(S[I], WordDelims) do
      Inc(I);
  end;
end;

//====================================================================================================================//

function WordPosition(const N: Integer; const S: string; const WordDelims: TSysCharSet): Integer;
var
  Count, I: Integer;
begin
  Count := 0;
  I := 1;
  Result := 0;
  while (I <= Length(S)) and (Count <> N) do
  begin
    { skip over delimiters }
    while (I <= Length(S)) and CharInSet(S[I], WordDelims) do
      Inc(I);
    { if we're not beyond end of S, we're at the start of a word }
    if I <= Length(S) then
      Inc(Count);
    { if not finished, find the end of the current word }
    if Count <> N then
      while (I <= Length(S)) and not CharInSet(S[I], WordDelims) do
        Inc(I)
    else
      Result := I;
  end;
end;

//====================================================================================================================//

function ExtractDelimited(N: Integer; const S: string; const Delims: TSysCharSet): string;
var
  CurWord: Integer;
  I, Len, SLen: Integer;
begin
  CurWord := 0;
  I := 1;
  Len := 0;
  SLen := Length(S);
  SetLength(Result, 0);
  while (I <= SLen) and (CurWord <> N) do
  begin
    if CharInSet(S[I], Delims) then
      Inc(CurWord)
    else
    begin
      if CurWord = N - 1 then
      begin
        Inc(Len);
        SetLength(Result, Len);
        Result[Len] := S[I];
      end;
    end;
    Inc(I);
  end;
end;

function ExtractWord(N: Integer; const S: string; const WordDelims: TSysCharSet): string;
var
  I: Integer;
  Len: Integer;
begin
  Len := 0;
  I := WordPosition(N, S, WordDelims);
  if I <> 0 then
    { find the end of the current word }
    while (I <= Length(S)) and not CharInSet(S[I], WordDelims) do
    begin
      { add the I'th character to result }
      Inc(Len);
      SetLength(Result, Len);
      Result[Len] := S[I];
      Inc(I);
    end;
  SetLength(Result, Len);
end;

//====================================================================================================================//

function GetFeldWert( sFelder, sDaten, sFeldName : String ) : String;
var i, iAnz, iPos : Integer;
begin

  Result := '';

  If sFelder = '' then Exit;
  If sDaten  = '' then Exit;

  iAnz := WordCount(sFelder, [';']);

  For i := 1 to iAnz do
    If ExtractWord(i, sFelder,[';'] ) = sFeldName then
    begin
      Result := ExtractDelimited( i, sDaten, [';'] );
      Break;
    end;

end;

//====================================================================================================================//

function TdmSpediFucs.Test : String ;
begin
  Showmessage('in TdmPzs');
end;

//====================================================================================================================//

procedure TdmSpediFucs.WebDataModuleCreate(Sender: TObject);
begin
  XDataWebClient.Connection := frmMainForm.XDataConn;

end;

//====================================================================================================================//

procedure TdmSpediFucs.Clear_CBX_und_Objekte( aComboBox : TComboBox );
var i : Integer ;
    aObj : TObject;
begin

  If aComboBox.Items.Count > 0 then
  For i := 0 to aComboBox.Items.Count-1 Do
    Begin
      aObj := TObject( aComboBox.Items.Objects[i]) ;
      aObj.Free;
    End;
  aComboBox.Items.Clear ;

end;

//====================================================================================================================//

function TdmSpediFucs.Get_PaketDaten( aVonSL, aNachSL : TStringList; sPaket : String ) : Integer;
var i : Integer;
    sTmp : String;
begin

  Result := 0;

  aNachSL.Clear;

  For i := 0 to aVonSL.Count-1 Do
    Begin
      sTmp := aVonSL[i];
      If Copy(sTmp,1,2) = sPaket then aNachSL.Add( Copy(sTmp,4,Length(sTmp)) );
    End;

  Result := aNachSL.Count;

end;

//====================================================================================================================//



procedure TdmSpediFucs.LoadDFMValues;
begin
  inherited LoadDFMValues;

  XDataWebClient := TXDataWebClient.Create(Self);

  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'dmSpediFucs';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    Height := 574;
    Width := 503;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Left := 116;
    XDataWebClient.Top := 80;
  finally
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
